import * as React from 'react'
import CustomModal from 'src/components/containers/CustomModal'
import TextInput from 'src/components/atoms/input/TextInput'
import { StoreProps } from 'src/stores'
import { inject } from 'mobx-react'
import FeedbackText from '../../atoms/FeedbackText'
import { RedBtn } from '../../atoms/input/buttons'

interface Props extends StoreProps {
  open: boolean
  onClose: () => void
}

interface State {
  emailAddress: string
  showErrorMessage: boolean
  showSuccessMessage: boolean
}

@inject('confStore')
export class Sharing extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      emailAddress: '',
      showErrorMessage: false,
      showSuccessMessage: false
    }
  }

  sendSharingEmail = () => {
    const { emailAddress } = this.state
    const { confStore } = this.props
    confStore
      .sendSharingEmail(emailAddress)
      .then((status) => {
        if (status) {
          this.setState({ showSuccessMessage: true, emailAddress: '' })
        } else {
          this.setState({ showErrorMessage: true })
        }
      })
      .catch((r) => {
        console.error(r)
        this.setState({ showErrorMessage: true })
      })
  }

  setEmailAddress = (e) => {
    this.setState({ emailAddress: e })
  }

  cleanUpAndClose = () => {
    const { onClose } = this.props
    this.setState({
      emailAddress: '',
      showErrorMessage: false,
      showSuccessMessage: false
    })
    onClose()
  }

  validateEmailAddress = () => {
    const { emailAddress } = this.state
    if (
      emailAddress.length > 4 &&
      emailAddress.split('@').length === 2 &&
      emailAddress.includes('.') &&
      (emailAddress.indexOf(' ') === emailAddress.length - 1 ||
        emailAddress.indexOf(' ') === -1)
    )
      return true
    return false
  }

  render() {
    const { open } = this.props
    const { emailAddress, showErrorMessage, showSuccessMessage } = this.state
    return (
      <CustomModal
        title='Mit Familie teilen'
        open={open}
        onClose={this.cleanUpAndClose}
        cancelX>
        <p>
          Teilen Sie die Bestattungsplanung mit Ihrer Familie. Geben Sie dafür
          einfach eine E-Mail-Adresse ein. Anschließend schicken wir Ihre
          Planung direkt an die Person.
        </p>
        <TextInput
          value={emailAddress}
          name='email'
          placeholder='E-Mail *'
          onChange={this.setEmailAddress}
          validate={this.validateEmailAddress}
        />
        <RedBtn
          disabled={!this.validateEmailAddress()}
          onClick={this.sendSharingEmail}>
          Teilen
        </RedBtn>
        <FeedbackText error visible={showErrorMessage}>
          Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch
          einmal.
        </FeedbackText>
        <FeedbackText visible={showSuccessMessage}>
          Ihre Planung wurde erfolgreich geteilt.
        </FeedbackText>
      </CustomModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/Sharing.tsx